import { ReactNode } from 'react';
import { Box, BoxProps, Tooltip as CKTooltip } from '@chakra-ui/react';
import { Colors } from '@mercator-gcp/grout';
import type { TooltipProps } from '@chakra-ui/react';

const innerSpanStyle = (fullWidth: boolean) => ({
  display: 'flex',
  width: fullWidth ? '100%' : 'fit-content',
});

type TTooltip = {
  tooltipText: string | string[] | ReactNode;
  shouldRenderTooltip?: boolean;
  isDisabled?: boolean;
  children: ReactNode;
  placement?: TooltipProps['placement'];
  sx?: BoxProps['sx'];
  fullWidth?: boolean;
  shouldWrapChildren?: boolean;
  isOpen?: boolean | undefined;
};

const Tooltip = ({
  shouldRenderTooltip = true,
  tooltipText,
  placement = 'top',
  isDisabled = false,
  sx = {},
  fullWidth = false,
  shouldWrapChildren = true,
  isOpen = undefined,
  children,
}: TTooltip) => {
  if (!shouldWrapChildren) {
    return (
      <CKTooltip
        placement={placement}
        hasArrow
        label={shouldRenderTooltip && tooltipText}
        color="white"
        backgroundColor={Colors.ArmyGreen900}
        paddingX="padding_8"
        paddingY="padding_4"
        borderRadius="4px"
        isDisabled={isDisabled}
        isOpen={isOpen}
      >
        {children}
      </CKTooltip>
    );
  }

  return (
    <CKTooltip
      placement={placement}
      hasArrow
      label={shouldRenderTooltip && tooltipText}
      color="white"
      backgroundColor={Colors.ArmyGreen900}
      paddingX="padding_8"
      paddingY="padding_4"
      borderRadius="4px"
      isDisabled={isDisabled}
      isOpen={isOpen}
    >
      <Box as="span" className="css-0" sx={{ ...innerSpanStyle(fullWidth), ...sx }}>
        {children}
      </Box>
    </CKTooltip>
  );
};

export default Tooltip;
